import React from "react";

const AutoApproveBankCandidateIcon = ({ cls }) => {
  return (
    <svg
      width="16"
      height="17"
      className={cls}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        d="M17,10c-3.86,0-7,3.141-7,7s3.14,7,7,7,7-3.141,7-7-3.14-7-7-7Zm0,12c-2.757,0-5-2.243-5-5s2.243-5,5-5,5,2.243,5,5-2.243,5-5,5Zm3.992-5.882l-3.457,3.399c-.308,.309-.727,.482-1.172,.482s-.864-.173-1.179-.488l-1.846-1.789,1.393-1.436,1.63,1.58,3.229-3.175,1.402,1.426Zm-12.992-4.118c3.309,0,6-2.691,6-6S11.309,0,8,0,2,2.691,2,6s2.691,6,6,6Zm0-10c2.206,0,4,1.794,4,4s-1.794,4-4,4-4-1.794-4-4,1.794-4,4-4Zm.523,12c-.226,.638-.388,1.305-.464,2h-3.059c-1.654,0-3,1.346-3,3v5H0v-5c0-2.757,2.243-5,5-5h3.523Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AutoApproveBankCandidateIcon;
